import { render, staticRenderFns } from "./SubheadersWithSocialMedia.vue?vue&type=template&id=c01402f4&"
import script from "./SubheadersWithSocialMedia.vue?vue&type=script&lang=js&"
export * from "./SubheadersWithSocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports